import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { catchError, switchMap, last } from 'rxjs/operators';
import { ErrorService } from 'src/app/services/error.service';
import { Course } from 'src/app/models/course.model';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
import { firestore } from 'firebase';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { SharedService } from 'src/app/services/shared.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.css']
})
export class CoursesComponent implements OnInit {

  public showSpinner: boolean;

  courses: Course[] = [];

  totalRecords: number = 0

  startRecord:number = 1

  ofRecords:number = 0

  limit: number = 50

  currentPage:number = 1

  numPages: PageIndex[] = []

  isNext$ = new Subject<boolean>()

  lastCourse:firestore.QueryDocumentSnapshot
  
  preCourse:firestore.QueryDocumentSnapshot

  home:string = 'Home'
  coursesText:string = 'English Courses'
  searchHere:string = 'Search here...'


  constructor(
    private service: CourseService,
    private route: ActivatedRoute,
    private router: Router,
    private sharedService:SharedService,
    private titleService: Title
  ) { 
    this.isNext$.subscribe(status=>{
      var numOfPages = Math.ceil(this.totalRecords/this.limit)
      if (status){
        if(this.currentPage >= numOfPages){
          return
        }
        this.currentPage += 1
      }else{
        if(this.currentPage <= 1){
          return
        }
        this.currentPage -= 1
      }
      console.log('current page',this.currentPage)
      this.getCourses(false,status)
    })
  }

  ngOnInit() {
    this.getCourses(true,true);
    this.needTranslate()

    const id = 'YQ1HXGaWqZxLelJEpv5L';
    this.sharedService.getBanner(id).then(result=>{
      const imageUrl = result.image.fileUrl;
      document.getElementById('bg-cover').style.backgroundImage = 'url(' + imageUrl + ')';
    })
    this.titleService.setTitle(`${getLocalTranslate('courses',this.coursesText)} | CamEdu`);
  }

  needTranslate(){
    this.home = getLocalTranslate('home',this.home)
    this.coursesText = getLocalTranslate('courses',this.coursesText)
    this.searchHere = getLocalTranslate('search-here',this.searchHere)
  }

  getCourses(firstTime:boolean,isNext:boolean) {
    var paramCourse:firestore.QueryDocumentSnapshot
    if (!firstTime){
      if(isNext){
        // Next
        paramCourse = this.lastCourse
      }else{
        // Pre
        paramCourse = this.preCourse
      }
    }
    console.log(this.ofRecords);
    this.showSpinner = true
    this.service.findAllWithPagination(this.limit,isNext,paramCourse).then(result => {
      const courses = result[0]
      const lastDoc = result[1]
      const preDoc  = result[2]
      this.lastCourse = lastDoc
      this.preCourse = preDoc
      this.courses = courses.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
      this.showSpinner = false
      if(firstTime){
        this.ofRecords += courses.length;
      }else{
        if(isNext){
          this.startRecord = this.ofRecords
          this.ofRecords += courses.length;
        }else{
          if(this.currentPage === 1){
            this.startRecord = 1
            this.ofRecords = courses.length;
          }else{
            this.ofRecords -= courses.length;
            this.startRecord = this.ofRecords
          }
        }
        console.log(this.startRecord)
      }

    })

    this.service.findAllActive().subscribe(result => {
      this.totalRecords = result.length
    })

  }

  routeToCourseDetail(id: string) {
    this.router.navigate(['/course/' + id]);
  }

  getFieldValue(value: string): string {
    return value === '' ? "N/A" : value
  }

  onNext(status:boolean){
    this.isNext$.next(status)
  }

}

export class PageIndex {
  index: number
  current: boolean
}